import { BaseApi } from "./BaseApi";

export class FilialApi extends BaseApi {
    async obterConfiguracao() : Promise<{
        CodigoFilial: string,
        Cor: string
    }> {
        return (await this.api.get(`/Comum/ObterConfiguracaoFilial`)).data
    }
}